import { Grid, Modal, Button, Typography, useMediaQuery } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import Box from '@mui/material/Box';
import EmployeeDetailPageStore from '../store/EmployeeDetailPageStore';
import { useMediaQueryState } from 'hooks/useMediaQueryState';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import outlookIcon from '../../../assets/image/outlookIcon.svg';

interface HTMLContentModalProps {
  pageStore?: EmployeeDetailPageStore;
  isOpen: boolean;
  handleClose: () => void;
  onClickCancel?: () => void;
}

const style = {
  position: 'absolute' as 'absolute',
  width: '80%',
  height: '100%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '15px',
  paddingTop: '60px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  '&:focus': {
    outline: 'none',
  },
};

function HTMLContentModal(props: HTMLContentModalProps) {
  const { pageStore, handleClose } = props;
  const { isPC } = useMediaQueryState();

  const handleClickCreateInvisibleAdvice = () => {
    if (pageStore?.tabsValue === 'TODO') {
      pageStore?.setIsCloseModal(true);
    } else {
      pageStore?.setIsCloseEditModal(true);
    }
  };

  const handleClickCreateVisibleAdvice = () => {
    if (pageStore?.tabsValue === 'TODO') {
      pageStore?.setIsOpenModal(true);
    } else {
      pageStore?.setIsOpenEditModal(true);
    }
  };

  const isMobile = useMediaQuery('(max-width: 600px)');
  if (isMobile) {
    style['width'] = '100%';
    style['height'] = '100%';
    style['borderRadius'] = '0px';
  }
  return (
    <Modal
      open={props.isOpen}
      onClose={props.handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={style}>
        {pageStore?.selectedTask.subtype === 'EMAIL' ? (
          <Grid container alignItems={'center'} style={{ marginBottom: '20px' }}>
            <Grid item xs={1}>
              <img src={outlookIcon} width='20px' height='20px' alt='outlookIcon' />
            </Grid>
            <Grid item xs={11}>
              <Typography
                style={{
                  fontStyle: 'normal',
                  fontWeight: 700,
                  fontSize: '18px',
                  lineHeight: '18px',
                  color: '#171918',
                }}
              >
                {pageStore?.selectedTask.title}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}

        <div
          style={{
            maxHeight: isPC ? '60vh' : 'calc(100vh - 0px)',
            maxWidth: isPC ? '500px' : '100vw',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            marginTop: '30px',
            lineHeight: '16px',
            color: '#171918',
            overflow: 'scroll',
          }}
          dangerouslySetInnerHTML={{
            __html: pageStore?.selectedTask.userData?.body?.content as any,
          }}
        ></div>
        <CloseIcon sx={{ position: 'absolute', right: '18px', top: '18px', cursor: 'pointer' }} onClick={handleClose} />
        <Grid container style={{ marginTop: '20px' }} gap={1} justifyContent='center'>
          <Button
            style={{
              color: '#000000',
              borderRadius: '6px',
              height: '36px',
              width: '80px',
              marginBottom: '6px',
              cursor: 'pointer',
              border: '1px solid #aaaaaa',
            }}
            onClick={handleClickCreateInvisibleAdvice}
          >
            <div
              style={{
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '12px',
                lineHeight: '12px',
                display: 'flex',
                cursor: 'pointer',
                alignItems: 'center',
              }}
            >
              <VisibilityOffIcon />
              <span style={{ marginLeft: '4px' }}>비공개</span>
            </div>
          </Button>
          <Button
            style={{
              background: '#2281D0',
              color: '#ffffff',
              borderRadius: '6px',
              cursor: 'pointer',
              height: '36px',
              width: '80px',
            }}
            onClick={handleClickCreateVisibleAdvice}
          >
            <div
              style={{
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '12px',
                lineHeight: '12px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <SendIcon />
              <span style={{ marginLeft: '4px' }}>공개</span>
            </div>
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}

export default observer(HTMLContentModal);
